import { render, staticRenderFns } from "./Organisations.vue?vue&type=template&id=10ffc0b4&scoped=true"
import script from "./Organisations.vue?vue&type=script&lang=js"
export * from "./Organisations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ffc0b4",
  null
  
)

export default component.exports